import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoService } from '@dash/randy/security/service/cognito.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApplicationsModel } from '@dash/randy/modules/admin-panel/applications/classes/applications.model';
import { application } from 'express';

@Component({
  selector: 'app-select-application',
  templateUrl: './select-application.component.html',
  styleUrls: ['./select-application.component.scss'],
  standalone: false,
})
export class SelectApplicationComponent implements OnInit {
  public applications: ApplicationsModel[] = [];
  public searchTerm = '';

  redirectUrl: string | null = null;

  constructor(
    private cognitoService: CognitoService,
    private router: Router,
    private route: ActivatedRoute,
    private locationStrategy: LocationStrategy,
  ) {
    this.route.queryParamMap.pipe(takeUntilDestroyed()).subscribe(params => {
      const redirect = params.get('redirect');
      if (redirect) {
        this.redirectUrl = redirect;
      }
    });

  }

  ngOnInit(): void {
    this.applications = this.cognitoService.getApplications();
    console.log('Applications Loaded', this.applications);

    if (this.applications.length === 1) {
      this.selectApplication(this.applications[0]);
    }
  }

  selectApplication(application: ApplicationsModel): void {
    this.cognitoService.selectApplication(application).then(res => {
      sessionStorage.clear();

      if (this.redirectUrl) {
        this.navigateWithReload(this.redirectUrl);
        return;
      }

      const dashboardUrl = this.router.serializeUrl(this.router.createUrlTree(['/dashboard', 'collection-items']));
      this.navigateWithReload(dashboardUrl);
    });
  }

  private navigateWithReload(url: string): void {
    window.location.href = this.locationStrategy.prepareExternalUrl(url);
  }

  get filteredApplications(): ApplicationsModel[] {
    const search = this.searchTerm.trim().toLocaleLowerCase();

    if (!search) {
      return this.applications;
    }

    return this.applications.filter(application =>
      application.name.toLocaleLowerCase().includes(search) ||
      application.id.toLocaleLowerCase().includes(search),
    );
  }
}
